<template>
  <section>
    <h1>{{section.description}}</h1>
    <slot name="top"></slot>
    <component
      v-for="entity in section.children"
      :key="entity.id"
      :is="typeToComponent(entity.field.type)"
      :entity="entity"></component>
    <slot name="bottom"></slot>
  </section>
</template>

<script>
  import { capitalize } from 'lodash'
  import BooleanField from './fields/boolean-field'
  import CurrencyField from './fields/currency-field'
  import DateField from './fields/date-field'
  import TimeField from './fields/time-field'
  import DatetimeField from './fields/datetime-field'
  import EmailField from './fields/email-field'
  import NumberField from './fields/number-field'
  import PicklistField from './fields/picklist-field'
  import PhoneField from './fields/phone-field'
  import TextField from './fields/text-field'
  import TextareaField from './fields/textarea-field'

  export default {
    components: {
      BooleanField,
      CurrencyField,
      DateField,
      TimeField,
      DatetimeField,
      EmailField,
      NumberField,
      PicklistField,
      PhoneField,
      TextField,
      TextareaField
    },
    props: ['section'],
    methods: {
      typeToComponent (type) {
        // example type => text, picklist, etc
        return `${capitalize(type)}Field`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// custom-section.vue?125e8492